import {
  NOTE_ANSWER,
  SET_PIXEL_OBJECT,
  SET_USER_EMAIL,
  SET_USER_SUM,
  SET_REMOTE_CONFIG_VALUES,
  SET_AUDIO_VALUE,
  HANDLE_SET_THEME,
  SET_ANALYTICS_INIT,
  SET_LANDING_ID,
} from "./actions";

const ACTION_HANDLERS = {
  [NOTE_ANSWER]: (state, action) => {
    return {
      ...state,
      answers: { ...state.answers, [action.route]: action.answerArray },
    };
  },
  [SET_USER_EMAIL]: (state, action) => {
    return {
      ...state,
      userEmail: action.payload,
    };
  },
  [SET_USER_SUM]: (state, action) => {
    return {
      ...state,
      userSum: action.payload,
    };
  },
  [SET_PIXEL_OBJECT]: (state, action) => {
    return {
      ...state,
      pixelObject: action.payload,
    };
  },
  [SET_REMOTE_CONFIG_VALUES]: (state, action) => {
    return {
      ...state,
      remoteConfig: action.payload,
    };
  },
  [SET_AUDIO_VALUE]: (state, action) => {
    return {
      ...state,
      audioValues: action.payload,
    };
  },
  [HANDLE_SET_THEME]: (state, action) => {
    return {
      ...state,
      theme: action.payload,
    };
  },
  [SET_ANALYTICS_INIT]: (state, action) => {
    return {
      ...state,
      isAnalyticsInit: action.payload,
    };
  },
  [SET_LANDING_ID]: (state, action) => {
    return {
      ...state,
      landingId: action.payload,
    };
  },
};

const initialState = {
  answers: {},
  userEmail: "",
  userSum: "",
  pixelObject: {},
  remoteConfig: {},
  audioValues: [0, 0, 0, 0],
  theme: null,
  isAnalyticsInit: false,
  landingId: null,
};

export default (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
};
